<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        <i class="fa fa-money mr-2 text-secondary"></i>
        {{title}}
    </ng-container>

    <ng-container dialog-process-in-progress *ngIf="feesForm && feesForm.form">
        <form [formGroup]="feesForm.form">
            <ng-container [formArrayName]="feesForm.feesArraySelector">
                <ng-container [formGroupName]="'0'">
                    <div>
                        <app-panel-input
                            [formControlName]="feesForm.controls[0].feeGroup.name"
                            [control]="feesForm.controls[0].feeGroup"
                        ></app-panel-input>
                    </div>
                    <div [ngClass]="{'mb-3': feesForm.controls[0].feeType.errors > 0}">
                        <app-select
                            [formControlName]="feesForm.controls[0].feeType.name"
                            [control]="feesForm.controls[0].feeType"
                        ></app-select>
                    </div>
                    <div [ngClass]="{'mb-3': feesForm.controls[0].fee.errors > 0}">
                        <app-select
                            [formControlName]="feesForm.controls[0].fee.name"
                            [control]="feesForm.controls[0].fee"
                        ></app-select>
                    </div>
                    <ng-container *ngIf="feesForm.isValidityPerAccount">
                        <div [ngClass]="{'mb-3': feesForm.controls[0].startDate.errors > 0}">
                            <app-datepicker
                                [formControlName]="feesForm.controls[0].startDate.name"
                                [control]="feesForm.controls[0].startDate"
                            ></app-datepicker>
                        </div>
                        <div [ngClass]="{'mb-3': feesForm.controls[0].endDate.errors > 0}">
                            <app-datepicker
                                [formControlName]="feesForm.controls[0].endDate.name"
                                [control]="feesForm.controls[0].endDate"
                            ></app-datepicker>
                        </div>
                    </ng-container>
                    <ng-container >
                        <div class="alert alert-warning" role="alert" *ngIf="showEndDateWarning">
                            Setting a date in the past requires recalculation of this fee plan!
                          </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </form>
    </ng-container>
</app-dialog>

